// extracted by mini-css-extract-plugin
export default {"control":"DisplayPanel_control__bcj8e"};